import endpoints, { axios } from "../config/api";

function deleteNotification(notificationId: number) {
  return axios.delete(endpoints.account.deleteNotification(notificationId));
}

export default deleteNotification;
